/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, Monitoraggio } from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-toolkit-opera-modal-monitoraggio',
    templateUrl: './modal-monitoraggio.component.html',
})
export class ToolkitGestioneOperaModalMonitoraggioComponent implements OnInit {
    
    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() params: Monitoraggio;
    @Input() datalist: DatalistAnagrafica;

    public criteriaForm: FormGroup;
    
    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idInterventoMonitoraggio: this.fb.control(null),
            idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
            idTipoIntervento: this.fb.control(null),
            efficienza: this.fb.control(null),
            efficacia: this.fb.control(null),
            enteEsecutore: this.fb.control(null),
            dataEsecuzione: this.fb.control(null),
            dataProssimaIspezione: this.fb.control(null),
            linkSchedaMonitoraggio: this.fb.control(null),
            note: this.fb.control(null)
        });
        if (this.params) {
            this.criteriaForm.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
    }

    public saveMonitoraggio() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        this.activeModal.close(this.criteriaForm);
    }

}
